"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAlertWarning = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconAlertWarning = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M10.924 13.567h2.15V7.59h-2.15v5.977ZM12 16.977c.313 0 .58-.11.8-.332.222-.222.333-.489.333-.8 0-.313-.11-.58-.332-.801a1.091 1.091 0 0 0-.8-.333c-.313 0-.58.111-.801.333a1.091 1.091 0 0 0-.332.8c0 .312.11.58.332.8.221.222.488.333.8.333Zm-.025 6.186L.836 12.025 12.024.836l11.139 11.139-11.189 11.188ZM12 20.15 20.15 12 12 3.85 3.85 12 12 20.15Z"
}));
exports.IconAlertWarning = IconAlertWarning;
//# sourceMappingURL=IconAlertWarning.js.map